import React from 'react';
import { Chip } from '@mui/material';

export const buildStatusChip = (meta) => {
  const label = meta.label || 'Unknown';
  const color = meta.color && meta.color !== 'default' ? meta.color : 'default';
  const variant = color === 'default' ? 'outlined' : 'filled';
  return <Chip size="small" label={label} color={color} variant={variant} />;
};
